import { FC } from 'react'
import Error from 'next/error'
import { useRouter } from 'next/router'
import useAuthorization, { useDomainAllowed } from '@/hooks/useAuthorization'
import { FullWidthLoader } from '@saasalerts/ui'
import { isLoginPage, isPublicRoute } from '@/utils/constants'

/**
 * Ensures that the page you are trying to access is allowed based on user's role
 * and domain restrictions
 */
export const AuthorizationGuard: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const router = useRouter()
  const { isAllowed, loading } = useAuthorization()
  const isDomainAllowed = useDomainAllowed(router.pathname)

  if (isPublicRoute(router.pathname)) {
    return <>{children}</>
  }

  if (!isDomainAllowed) {
    return <Error statusCode={404} />
  }

  const isCurrentPageLoginPage = isLoginPage(router.pathname)

  if (isCurrentPageLoginPage) {
    return <>{children}</>
  }

  if (loading) {
    return <FullWidthLoader />
  }
  if (!isAllowed(router.pathname)) {
    return <Error statusCode={404} />
  }
  return <>{children}</>
}
